import {Component, inject, isDevMode} from '@angular/core';
import {FormsModule}                  from '@angular/forms';
import {LogrAuthService}              from '../../utils/logr-auth.service';
import {AuthWrapperComponent}         from '../auth-wrapper/auth-wrapper.component';

@Component({
			   selector   : 'app-auth-entry',
			   imports    : [
				   FormsModule,
				   AuthWrapperComponent
			   ],
			   templateUrl: './auth-entry.component.html',
			   styleUrl   : './auth-entry.component.css'
		   })
export class AuthEntryComponent {
	public svcAuth = inject(LogrAuthService)
	protected readonly isDevMode = isDevMode;
}
